import {connect} from 'react-redux';

export default connect(state => ({
  timesheetPath: '/timesheet/' + state.timesheet.timesheetDate,
  approvalPath: state.approval.currentPath
}));
